<div class="container-fluid">
  <div class="mega_body-content">
    <div class="col-12- col-sm-12 col-md-12 col-lg-12">
      <ng-container *ngIf="isInvalidFileFormat || isMultipleFiles">
        <div class="row file-format-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-8 col-sm-8 col-md-8 col-lg-9" *ngIf="!isMultipleFiles">
            <p class="file-format-text">{{ displayErrorMessage }}</p>
          </div>
          <div *ngIf="isMultipleFiles" class="col-8 col-sm-8 col-md-8 col-lg-9">
            <p class="file-format-text">{{ displayErrorMsgForMultipleFiles }}</p>
          </div>
          <div class="col-3 col-sm-3 col-md-3 col-lg-2">
            <div class="exit-button float-end" (click)="closeErroMessageBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="hasFileExtensionError || isFileCorrupted || isFileEmpty || isFilePasswordProcted"
      >
        <div class="row error-banner-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-9 col-lg-9">
            <p class="file-format-text" id="banner-error-msg">{{ showBannerErrorMsg }}</p>
          </div>
          <div class="col-1 col-sm-1 col-md-2 col-lg-2">
            <div class="exit-button float-end" (click)="closeMessageBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showCancelBanner">
        <div class="row file-format-container file-format-cancel-banner-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <span><i class="fa fa-check-circle-o cancel-banner-checkmark"></i></span>
            </div>
          </div>
          <div class="col-8 col-sm-8 col-md-8 col-lg-9">
            <p class="file-format-text">{{ displayCancelErrorMessage }}</p>
          </div>
          <div class="col-3 col-sm-3 col-md-3 col-lg-2">
            <div class="exit-button float-end" (click)="closeCancelMessageBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showFileUploadFailBanner">
        <div class="row file-format-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-8 col-sm-8 col-md-8 col-lg-9">
            <p class="file-format-text">{{ displayFileUploadErrorMessage }}</p>
          </div>
          <div class="col-3 col-sm-3 col-md-3 col-lg-2">
            <div class="exit-button float-end" (click)="closeFileUploadMessageBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Upload File</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>
    <ng-container *ngIf="collateralDueMegaList === null">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end">
        <span>
          <i class="fa fa-download download-template" (click)="downloadPoolInfoTemplate()"></i>
          <a class="download-pool-info-template" (click)="downloadPoolInfoTemplate()"
            >Download Pool Information Template (.xlsx)</a
          >
        </span>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <p>{{ collateralErrorMessage }}</p>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <br />
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <button
          class="button fm-primary-button"
          id="view-settled-megas-button"
          type="button"
          (click)="navigateToSettledMegas()"
          routerLink="mega-trade/settled-megas"
        >
          View Settled Pools
        </button>
      </div>
    </ng-container>
    <div class="row" *ngIf="collateralDueMegaList !== null">
      <div class="col-12 col-sm-12 col-md-4 col-lg-4">
        <div class="upload-file-container">
          <div class="row">
            <ng-container *ngIf="showFileUploadScreen && !LDshowCollateralUploadParseFile">
              <div
                class="drag-drop-file-container"
                invdFileDragDrop
                [isMultipleFiles]="isMultipleFiles"
                (filesDropped)="handleDrop($event)"
                (filesHovered)="dropzoneState($event)"
                [ngClass]="{ active: dropzoneActive }"
              >
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <span><i class="fa fa-upload file-upload-arrow"></i></span>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <p class="drag-file-to-upload-header">Drag File to Upload</p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <p class="drag-file-or-text file-parse-select">or</p>
              </div>
              <div
                class="col-12 col-sm-12 col-md-12 col-lg-12"
                style="text-align: center; margin-top: -87px"
                *ngIf="!LDshowCollateralUploadParseFile"
              >
                <input
                  type="file"
                  style="display: none"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  (change)="onPoolUpload($event)"
                  #file
                />
                <button
                  class="button fm-primary-button"
                  id="select-file-button"
                  (click)="file.click()"
                >
                  Select File
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="!showFileUploadScreen">
              <div class="drag-drop-file-container-scanning">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <span><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i></span>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <p class="drag-file-to-upload-process-header">Scanning File</p>
                </div>

                <button
                  class="button fm-tertiary-button"
                  (click)="cancelUpload()"
                  [disabled]="isCancelLinkClicked"
                >
                  Cancel
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="showFileUploadScreen && LDshowCollateralUploadParseFile">
              <div
                class="drag-drop-file-container"
                invdFileDragDrop
                [isMultipleFiles]="isMultipleFiles"
                (filesDropped)="handleDropParseFile($event)"
                [ngClass]="{ active: dropzoneActive }"
              >
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <span><i class="fa fa-upload file-upload-arrow"></i></span>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <p class="drag-file-to-upload-header file-parse">Select File to Upload</p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 visible-md-12">
                <div
                  class="col-md-12 col-lg-12 upload-collateral-button-margin upload-parse-button"
                >
                  <invd-fm-xlsx-json
                    [showJson]="false"
                    [stringFormat]="true"
                    [displayLabel]="'Select File'"
                    [successMsg]="false"
                    [buttonLabel]="'Select File'"
                    (showFileName)="showFileName($event)"
                    (showFileExtensionError)="showFileExtensionError($event)"
                    (getExcelSheetsContent)="getExcelSheetsContent($event)"
                    (showIsFileCorrupted)="showIsFileCorrupted($event)"
                  >
                  </invd-fm-xlsx-json>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-4 col-lg-4">
        <h6 class="file-specifications">FILE SPECIFICATIONS:</h6>
        <p class="file-spec-info-text">
          Files must be in Excel format. For each pool, create a tab and re-name the label using
          that pool's Pool Number. Each sheet must contain the below column headers in order.
        </p>
        <br />
        <p>1. CUSIP</p>
        <p>2. Original Face</p>
      </div>
      <div class="col-12 col-sm-12 col-md-4 col-lg-4 d-flex flex-column">
        <span class="ms-auto">
          <i class="fa fa-download download-template" (click)="downloadPoolInfoTemplate()"></i>
          <a class="download-pool-info-template" (click)="downloadPoolInfoTemplate()"
            >Download Pool Information Template (.xlsx)</a
          >
        </span>
        <p class="info-for-multiple-megas">
          You may only upload one Excel file at a time.<br />
          To upload pool information for multiple pools, add a tab to your Excel file for each
          additional pool.
        </p>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
        <div class="line-break"></div>
      </div>
      <div class="row col-12 col-sm-12 col-md-12 col-lg-12 gx-0">
        <div class="col-12 col-sm-12 col-md-3 col-lg-3 pool-information-due-with-total">
          <span class="pool-information-due-header">Pool Information Due</span>
        </div>
        <div class="col-12 col-sm-12 col-md-9 col-lg-9 d-flex justify-content-end">
          <span class="total-count-for-pool"
            >Total Pools: {{ collateralDueMegaList ? collateralDueMegaList?.length : '' }}</span
          >
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="collateralDueMegaList !== null">
        <div class="fm-cdx-table">
          <table class="fm-cdx-table__static">
            <thead>
              <tr class="th_row">
                <th class="th_column">POOL #</th>
                <th class="th_column width-25">CUSIP</th>
                <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                <th class="th_column pl-85">SETTLEMENT</th>
                <th class="th_column">DUE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="td_row commit-mega-table-header"
                *ngFor="let poolItem of collateralDueMegaList; trackBy: trackByIdentity"
              >
                <td class="td_cell">
                  <span class="pool-item-mega-number">{{ poolItem?.poolNumber }}</span>
                </td>
                <td class="td_cell">
                  <span class="pool-item-cusip">{{ poolItem?.cusip }}</span>
                </td>
                <td class="td_cell td_cell--is-numeric">
                  <span class="pool-item-trade-amount">{{
                    poolItem?.tradeAmount | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span>
                </td>
                <td class="td_cell pl-85">
                  <span class="pool-item-settlement-date">{{
                    poolItem?.tradeSettlementDate | date: 'MM/dd/yyyy'
                  }}</span>
                </td>
                <td class="td_cell">
                  <span
                    *ngIf="poolItem.status === 'DUE'; else showdueDateRed"
                    class="pool-item-due-date"
                    >{{ poolItem?.statusDate | date: 'MM/dd/yyyy' }}</span
                  >
                  <ng-template #showdueDateRed>
                    <span class="due-date-red">{{
                      poolItem?.statusDate | date: 'MM/dd/yyyy'
                    }}</span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="validation-pool-model-window" *ngIf="displayNavigateAwayPopup">
      <div class="panel panel-default fadeInUpBig">
        <div class="panel-body pool-info-cancel-confirmation-model">
          <h4>You are attempting to leave this page.</h4>
          <br />
          <p>
            By doing so, none of your pool information will be allocated and all of your work to
            this point will be lost.
          </p>
          <br />
          <h4>Do you wish to proceed?</h4>
          <br />
          <button class="button fm-tertiary-button" (click)="continuePollingUploadStatus()">
            NO
          </button>
          <button class="button fm-primary-button" (click)="navigatePageTo(destinationUrl)">
            YES
          </button>
        </div>
      </div>
    </div>

    <ng-container *ngIf="showIEAnalyzerPopUp">
      <div class="IE-message-model-window">
        <div class="panel panel-default fadeInUpBig">
          <div class="row">
            <div class="col-sm-6 col-6 col-md-6 col-lg-6">
              <h2 class="cancel-popup-title" id="cancel-popup-title">Message</h2>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup-IE">
              <div class="line-break"></div>
            </div>
          </div>
          <div class="panel-body">
            <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
              <div class="col-1 col-sm-1 col-md-1 col-lg-1 exclamation-pos">
                <i
                  class="fa fa-exclamation-triangle warning-exclamation-icon"
                  id="warning-icon"
                ></i>
              </div>
              <div class="col-12 col-sm-12 col-md-11 col-lg-11 IEmessage">
                <p id="do-you-proceed-text">This feature is not compatible with IE.</p>
                <p class="mt-top">
                  Please use another browser if possible (Microsoft Edge, Google Chrome, Mozilla
                  Firefox, etc.)
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 footer-block pr-20">
            <div class="float-end pl-0 pr-0">
              <button class="button fm-tertiary-button" (click)="navigateToHome()">Home</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
